import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";

import * as dashboardApi from "../../../../api/dashboardApi";
import { isEmptyArray } from "../../../../util";

import "../../../../assets/stlyes/Dashboard/LinearProgressBar.scss";

const SubEOYPrediction = (props) => {
  const { subjectOption } = props;
  const [data, setData] = useState();
  const [selectedSub, setSelectedSub] = useState(subjectOption[0].label);

  const getResultant = async (subjectName) => {
    const details = await dashboardApi.getPredictedOutcomeBySchoolId({ subjectName });
    if (!isEmptyArray(details?.Items)) {
      setData(details.Items?.map((subject) => {
        const details1 = Object.entries(subject.value).map(([grade, percentage]) => ({
          now: parseFloat(percentage),
          grade
        }));

        return {
          subject: subject.name,
          totalCount:subject.totalCount,
          details1
        };
      }))
    }
  }

  useEffect(() => {
    getResultant(subjectOption[0].value)
  }, [])

  return (
    <Card className="linearProgressMain">
      <Row>
        <Col>
          <p className="topic">End of Year Predictions: {selectedSub && selectedSub} by Group</p>
          <p className="subTopic">Group Performance Summary</p>
        </Col> 
        <Col className="dropDownZone">
          <select className="dropDownResult" defaultValue={selectedSub} onChange={(e) => { setSelectedSub(e.target.value); 
            getResultant(e.target.value) 
          }}
          >
            {
              subjectOption.map((item) => {
                return (<option key={item.value} value={item.value}>{item.label}</option>)
              })
            }
          </select>
        </Col>
      </Row>
      {/* <div className="progressSubjectDiv">
          {array && array.map((item) => {
            return (<div className="d-flex align-items-baseline progressSubDiv">
              {/* <p className="subjectNames">{item.subject}</p>
              <ProgressBar className="progressBarMain">
                {
                  item.details1.map((item2, index) => {
                    return (
                      <ProgressBar now={item2.now} key={index} background style={{ backgroundColor: item2.grade === "G" ? "var(--greater-colour)" : item2.grade === "E" ? "var(--expected-colour)" : item2.grade === "W" ? "var(--emerging-colour)" : "var(--below-colour)" }} label={`${item2.now}%`} />
                    )
                  })
                }
              </ProgressBar> 
              Hii
            </div>)
          })}
        </div> */}
      <Row>
        <div className="progressSubjectDiv">
          {data && data.map((item) => {
            return (item!=="pe"  && <div className="d-flex align-items-baseline progressSubDiv">
              <p className="subSubjectNames">{item.subject}&nbsp;({item.totalCount})</p>
              <ProgressBar className="progressBarMain">
                {
                  item.details1.map((item2, index) => {
                    return (
                      <ProgressBar now={item2.now} key={index} background style={{ backgroundColor: item2.grade === "G" ? "var(--greater-colour)" : item2.grade === "E" ? "var(--expected-colour)" : item2.grade === "W" ? "var(--emerging-colour)" : "var(--below-colour)" }} label={`${item2.now}%`} />
                    )
                  })
                }
              </ProgressBar>
            </div>)
          })}
        </div>
      </Row>
    </Card>
  );
}

export { SubEOYPrediction };